<template>
    <ClientOnly>
        <div class="flex items-center ml-auto min-w-fit">
            <div class="flex items-center w-full" :class="auth ? 'space-x-4' : 'space-x-2'">
                <AppCreditPopover v-if="auth && showCreditPopover" @click:credit-pack="showCreditPackDialog = true" />

                <AppButton
                    v-if="useDevice().isDesktop || (useDevice().isMobile && !auth)"
                    size="xsm"
                    id="get-started-header-button"
                    variant="outlined"
                    @click="handleStartShoppingClick"
                >
                    {{ $t('components_header_getStarted') }}
                </AppButton>

                <AppHeaderUserPopover v-if="auth" />
                <AppButton
                    v-else
                    id="login-header-button"
                    class="w-fit justify-center"
                    size="xsm"
                    variant="ghost"
                    @click="openAuthDialog"
                >
                    {{ $t('components_header_login') }}
                </AppButton>
            </div>
            <CreditPackPricingCreditPack />
        </div>
        <template #fallback>
            <div class="flex items-center ml-auto min-w-fit">
                <div class="flex items-center">
                    <div class="w-[80px] mr-5">
                        <AppSkeletonRectangle size="sm" />
                    </div>
                    <div class="w-[40px]">
                        <AppSkeletonRectangle size="sm" />
                    </div>
                </div>
            </div>
        </template>
    </ClientOnly>
</template>

<script setup lang="ts">
import AppCreditPopover from '~/features/authentication/components/user/AppCreditPopover.vue'
import { useLayoutDialog } from '~/store/components/layout-dialog.store'
import { useAuthStore } from '~/features/authentication/store'
import AppAuthForm from '~/features/authentication/components/AppAuthForm.vue'
import { useUserStore } from '~/store/global/user.store'

const { userData } = storeToRefs(useUserStore())

const { activeComponent, hasEmailPermission, showAuthModal } = storeToRefs(useAuthStore())

const showCreditPopover = computed(() => Object.keys(userData.value).length > 0 && userData.value.roles)

const { showCreditPackDialog } = storeToRefs(usePricingStore())

const auth = useAuth()

const route = useRoute()

const { openDialog, showGlobalDialog } = useLayoutDialog()

const openGlobalDialog = () => {
    openDialog({
        component: shallowRef(
            defineAsyncComponent({
                loader: () => import('~/features/authentication/components/AppAuthForm.vue')
            })
        )
    })
}
watch(showGlobalDialog, async () => {
    hasEmailPermission.value = false
})

// const showAuthModal = ref(false);
const isMobileMenuOpen = useMobileMenuOpen()

const openAuthDialog = () => {
    isMobileMenuOpen.value = false
    showAuthModal.value = true
    activeComponent.value = 'login'
}

const localePath = useLocalePath()

const handleStartShoppingClick = () => {
    if (route.meta.layout === 'shopping-hub-dashboard') {
        openDialog({
            title: 'Start a New Journey',
            component: shallowRef(
                defineAsyncComponent({
                    loader: () => import('../../global/app-shopping-hub-dialog/AppShoppingHubDialog.vue')
                })
            )
        })
    } else {
        return navigateTo(localePath('/dashboard/services'))
    }
}
</script>
